module.exports = __webpack_public_path__ + "static/feature-door-01-954277c25a3334a0464c110ca1b5226b.png";